var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { NativeInterfaceAbstractCommunication } from "./NativeInterfaceAbstractCommunication";
var NativeInterfaceWebsocket = /** @class */ (function (_super) {
    __extends(NativeInterfaceWebsocket, _super);
    function NativeInterfaceWebsocket(eventRouter) {
        var _this = _super.call(this, eventRouter) || this;
        _this.currentWebsocketConnection = null;
        _this.pendingRequests = [];
        _this.reconnectTimes = 0;
        _this._isConnected = false;
        _this.initWebsocketCommunication();
        return _this;
    }
    NativeInterfaceWebsocket.prototype.available = function () {
        return !window.location.protocol.startsWith('https') && typeof window.native !== 'undefined' && typeof window.native.getWebsocketPort === 'function';
    };
    NativeInterfaceWebsocket.prototype.isConnected = function () {
        return this._isConnected;
    };
    NativeInterfaceWebsocket.prototype.initWebsocketCommunication = function () {
        var _this = this;
        if (this.available()) {
            this.currentWebsocketConnection = new WebSocket('ws://127.0.0.1:' + window.native.getWebsocketPort() + '/');
            this.currentWebsocketConnection.onopen = function () {
                console.info('Event are now relayed to JAVA with the websocket');
                _this.reconnectTimes = 0;
                _this._isConnected = true;
                _this.sendAllPendingRequests();
            };
            this.currentWebsocketConnection.onmessage = function (event) {
                try {
                    var parsedResponse = JSON.parse(event.data);
                    _this.onCommunicationReceived(parsedResponse);
                }
                catch (e) {
                    console.log(e);
                    alert('Unable to establish proper communication' + e);
                }
            };
            this.currentWebsocketConnection.onclose = function (event) {
                _this._isConnected = false;
                // RECONNECT
                //THROW BIG ERROR
                setTimeout(function () {
                    ++_this.reconnectTimes;
                    if (_this.reconnectTimes >= 10) {
                        alert('Unable to establish proper communication after 10 retries');
                    }
                    else {
                        _this.initWebsocketCommunication();
                    }
                }, 500);
            };
            this.currentWebsocketConnection.onerror = function (error) {
                //THROW BIG ERROR
                //alert('Unable to establish proper communication('+JSON.stringify(error)+')');
            };
        }
    };
    NativeInterfaceWebsocket.prototype.sendAllPendingRequests = function () {
        if (this.currentWebsocketConnection && this.currentWebsocketConnection.readyState === WebSocket.OPEN) {
            for (var _i = 0, _a = this.pendingRequests; _i < _a.length; _i++) {
                var request = _a[_i];
                this.call(request);
            }
            this.pendingRequests = [];
        }
    };
    NativeInterfaceWebsocket.prototype.call = function (event) {
        if (this.currentWebsocketConnection && this.currentWebsocketConnection.readyState === WebSocket.OPEN) {
            this.currentWebsocketConnection.send(JSON.stringify(event));
        }
        else {
            this.pendingRequests.push(event);
        }
        return true;
    };
    return NativeInterfaceWebsocket;
}(NativeInterfaceAbstractCommunication));
export { NativeInterfaceWebsocket };
//# sourceMappingURL=NativeInterfaceWebsocket.js.map